import { SceneNames } from '../models/scene-names.enum';
import { WaterFaucetScene } from './water-faucet-scene';
import { LightSwitchScene } from './light-switch-scene';
import { TransportScene } from './transport-scene';
import { FinalScene } from './final-scene';

declare var AFRAME: any;

export class Scenes {
	private waterFaucetScene = new WaterFaucetScene();
	private transportScene = new TransportScene();
	private lightSwitchScene = new LightSwitchScene();
	private finalScene = new FinalScene();

	private currentSceneIndex = 0;
	private scenes = [
		SceneNames.WaterFaucet, //
		SceneNames.LightSwitch,
		SceneNames.Transport,
		SceneNames.Final,
	];

	private currentScene: SceneNames = SceneNames.WaterFaucet;

	public constructor() {}

	/** Starts the experience */
	public start(): void {
		this.initScene();
	}

	/** Initialises the current scene */
	private initScene(): void {
		switch (this.currentScene) {
			case SceneNames.WaterFaucet:
				this.waterFaucetScene.init();
				this.lightSwitchScene.createElements();
				this.waterFaucetScene.eventEmitter.addEventListener('finished', this.nextScene.bind(this), { once: true });
				break;
			case SceneNames.LightSwitch:
				this.lightSwitchScene.init();
				this.transportScene.createElements();
				this.lightSwitchScene.eventEmitter.addEventListener('finished', this.nextScene.bind(this), { once: true });
				break;
			case SceneNames.Transport:
				this.transportScene.init();
				this.finalScene.createElements();
				this.transportScene.eventEmitter.addEventListener('finished', this.nextScene.bind(this), { once: true });
				break;
			case SceneNames.Final:
				this.finalScene.init();
				break;
		}
	}

	/** Updates the currentSceneIndex and the currentScene and then starts the new scene */
	private nextScene(): void {
		this.currentSceneIndex += 1;
		this.currentScene = this.scenes[this.currentSceneIndex];
		this.initScene();
	}
}
